import api from '@/app/api/axios.js';

export const authApi = {
    login(credentials) {
        return api.post(
            '/general/oauth/token',
            {
                grant_type: 'password',
                ...credentials,
            },
            {
                login: true,
            }
        );
    },

    refresh(refreshToken) {
        return api.post(
            '/general/oauth/token',
            {
                grant_type: 'refresh_token',
                refresh_token: refreshToken,
            },
            {
                login: true,
            }
        );
    },

    register(credentials) {
        return api.post('/general/team', credentials);
    },

    confirmOTP(credentials) {
        return api.post('/general/oauth/confirm', credentials, {
            login: true,
        });
    },
};
